/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Legalguardian11Inputs */

const de__field_legalguardian11 = /** @type {(inputs: _Field_Legalguardian11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erster Erziehungsberechtigte Person`)
};

/**

* @param {_Field_Legalguardian11Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_legalguardian11 = /** @type {((inputs?: _Field_Legalguardian11Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Legalguardian11Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_legalguardian11(inputs)
});
export { _field_legalguardian11 as "_field_legalGuardian1" }